import labourPerson from "./labourPerson.js";

const top10 = labourPerson.slice(0, 10);
const other = labourPerson.slice(10);

// console.log(labourPerson, top10, other)

const config = {
    "tooltip": {
        "show": true,
        "trigger": "item"
    },
    "legend": {
        "show": false,

    },
    "color": ["#137AEF ", "#63BAFE", "#24BDBA", "#45E794", "#F28B6E", "#FD5F83", "#FCD164", "#F59D6C"],
    "geo": {
        "map": "china",
        // "center": [112.97, 37.50],
        "label": {
            "emphasis": {
                "show": false
            },
            "show": false,
            "color": "rgba(55, 171, 210, 0.75)"
        },
        "roam": false,
        "itemStyle": {
            "areaColor": "#161659",
            "borderColor": "#1b70a3",
            "borderWidth": 1,
            shadowOffsetX: -20,
            shadowColor: '#161659',
            shadowBlur: 1
        },
        "emphasis": {
            "areaColor": "#0C264D",
            "label": {
                "show": false
            },
            "itemStyle": {
                "areaColor": "#002864"
            }
        },
        "selectedMode": "single",
        "zoom": 1.2,
        "regions": [{
            "name": "China",
            "itemStyle": {
                // "borderWidth": 2,
                // "borderColor": "#37abd2",
                // "areaColor": "transparent",
                // "shadowColor": "rgba(33, 133, 240, 0.25)",
                // "shadowOffsetX": -15,
                // "shadowOffsetY": 4,
            },

        }]
    },
    "series": [{
            "type": "lines",
            "zlevel": 1,
            "effect": {
                "show": true,
                "period": 6,
                "trailLength": 0.7,
                "color": "rgba(71, 214, 208, 0.35)",
                // "symbolSize": [10, 20]
            },
            "lineStyle": {
                "color": "rgba(52,242,218,0.15)",
                "width": 2,
                "shadowBlur": 5,
                "curveness": 0.1
            },
            "tooltip": {
                "show": false
            },
            "data": getLine(),
        },

    ]
}



function getLine() {
    return top10.map((item) => {
            return {
                "fromName": item.from.name,
                "toName": item.to.name,
                "coords": [
                    item.from.coordinates,
                    item.to.coordinates
                ],
                "value": item.value,
                "effect": {
                    "show": true,
                    "period": 6,
                    "trailLength": 0.7,
                    "color": "rgba(71, 214, 208, 0.35)",
                    "symbolSize": [4, 8]
                },
                "lineStyle": {
                    "color": "rgba(52,242,218,0.15)",
                    "shadowColor": 'rgba(52,242,218,0.15)',
                    "width": 1,
                    "shadowBlur": 5,
                    "curveness": 0.1
                },
            };
        })
        .concat(
            other.map((item) => {
                return {
                    "fromName": item.from.name,
                    "toName": item.to.name,
                    "coords": [
                        item.from.coordinates,
                        item.to.coordinates
                    ],
                    "value": item.value,
                    "effect": {
                        "show": true,
                        "period": 6,
                        "trailLength": 0.7,
                        "color": "rgba(71, 214, 208, 0.35)",
                        "symbolSize": [2, 4]
                    },
                    "lineStyle": {
                        "color": "rgba(52,242,218,0.15)",
                        "width": 0.5,
                        "shadowBlur": 5,
                        "curveness": 0.1
                    },
                }
            })
        );

}


function getEffectScatterData(data) {
    const scatterOption = config.series;
    // debugger
    for (let index = 0; index < data.length; index++) {
        const item = data[index];
        const from = item.from;
        const to = item.to;
        // debugger
        const findFromConfig = scatterOption.findIndex((item) => {
            return item.data[0].name == from.name;
        });

        if (findFromConfig == -1) {
            
            scatterOption.push({
                "type": "scatter",
                "coordinateSystem": "geo",
                "zlevel": 30,
                "rippleEffect": {
                    // "brushType": "stroke"
                },
                "label": {
                    "show": true,
                    "position": "right",
                    "formatter": "{b}",
                    "fontSize": 20,
                    "color": "#ffffff",
                    "fontWeight": "bold",
                    "padding": [0, 0, 0, -50]
                },
                "itemStyle": {
                    "color": 'rgba(238,45,86,0.8)'
                },
                "data": [{
                    "name": from.name,
                    "value": from.coordinates,
                    "symbolSize": 1,
                }]

            });
        }

        const findToConfig = scatterOption.findIndex((item) => {
            return item.data[0].name == to.name;
        });

        if (findToConfig == -1) {
            // debugger
            scatterOption.push({
                "type": "scatter",
                "coordinateSystem": "geo",
                'rippleEffect': {
                    // brushType: 'stroke'
                },
                "zlevel": 2,
                "label": {
                    "show": true,
                    "position": "right",
                    "formatter": "{b}",
                    "unit": "%",
                    "fontSize": 10,
                    "color": "#ffffff",
                },
                "itemStyle": {
                    "color": "rgba(71, 214, 208, 0.8)",
                },
                "data": [{
                    "name": to.name,
                    "value": to.coordinates,
                    "symbolSize": 10,
                }]

            });
        }



    }

}
getEffectScatterData(other);
// console.log(JSON.stringify(config, null, 2));
export default config;